import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import AppSettings from 'src/app/common/app.settings';
import { SearchService } from 'src/app/components/search/search.service';
import { SearchFormTypes } from 'src/app/forms/forms.enum';
import { SelectorOption } from 'src/app/interfaces/form-and-field.interface';
import { safelyDetectChanges } from '../../../../common/app.helpers';
import { SelectorOptionsService } from '../selector-options.service';
import { SuggestionSearchFieldShared } from '../suggestion-search-field.shared';
import { MultipleSearchMapFormFieldService } from './helpers/multiple-search-map-form-field.service';

@Component({
  selector: 'app-multiple-search-map-form-field',
  templateUrl: './multiple-search-map-form-field.component.html',
  styleUrls: ['./multiple-search-map-form-field.component.scss'],
  providers: [SelectorOptionsService, SearchService],
})
export class MultipleSearchMapFormFieldComponent extends SuggestionSearchFieldShared {
  public selectedItems: SelectorOption[] = [];
  public SearchFormTypes: typeof SearchFormTypes = SearchFormTypes;

  protected selectorOptionsService = inject(SelectorOptionsService);
  protected searchFormFieldValueService = inject(MultipleSearchMapFormFieldService);
  protected changeDetector = inject(ChangeDetectorRef);

  public onSelectItem(event: NgbTypeaheadSelectItemEvent<SelectorOption>): void {
    event.preventDefault();

    this.selectedItems.push(event.item);
    this.multipleSearchInput.nativeElement.value = '';
    this.fillControlValue();

    this.searchFormFieldValueService.setFieldValue({
      field: this.fieldAttribute.backendAttribute.name,
      selectedItems: this.selectedItems,
    });
  }

  public onCloseItem(item: SelectorOption): void {
    this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
    this.multipleSearchInput.nativeElement.focus();
    safelyDetectChanges(this.changeDetector);
    this.fillControlValue();

    this.searchFormFieldValueService.setFieldValue({
      field: this.fieldAttribute.backendAttribute.name,
      selectedItems: this.selectedItems,
    });
  }

  public checkErrors(): void {
    this.formValidationService.checkMultipleSearchFieldValidationErrors(
      this.control,
      this.multipleSearchInput.nativeElement.value,
    );
  }

  protected getSelectedItems(): SelectorOption[] {
    return this.selectedItems;
  }

  protected onControlDisabled(): void {
    if (this.multipleSearchInput) {
      this.multipleSearchInput.nativeElement.value = '';
    }
  }

  protected override onNullControlValue(): void {
    this.selectedItems = [];
    super.onNullControlValue();
  }

  protected override subscribeToControlValueChanges() {
    super.setupControlValueChangesSubscription(false);
  }

  protected initSelectedItems(): void {
    this.selectedItems = (this.control.value as SelectorOption[]) || [];
    this.fillControlValue();
    this.subscribeToControlChanges();
    this.optionsService.getUpdatedOptions(this.fieldAttribute, this.initialSearchParams, this.selectedItems);
  }

  private fillControlValue(): void {
    this.control.setValue(
      this.selectedItems
        .map((selectedItem: SelectorOption) => selectedItem.entity_id)
        .join(AppSettings.FORM_FIELD_ARRAY_VALUE_SEPARATOR),
    );
  }
}
